"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.compareDate = exports.afterInstant = exports.daysBetween = exports.beforeDate = exports.beforeOrEqualsDate = exports.hasProperty = exports.isValidEmail = void 0;
var moment_1 = __importDefault(require("moment"));
var get_1 = __importDefault(require("lodash/get"));
/**
 * From https://stackoverflow.com/a/201378
 * RFC 5322
 * @param {string} input input string to test
 * @returns {boolean} whether or not the input is a validly formatted email.
 */
function isValidEmail(input) {
    if (!input) {
        return false;
    }
    var regex = /^\s*(?:[a-zA-Z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+\/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-zA-Z0-9-]*[a-zA-Z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])\s*$/;
    return regex.test(input);
}
exports.isValidEmail = isValidEmail;
/**
 * @param object Object to check if property exists
 * @param path a '.' separated path string, or array of subpaths
 * @returns whether the data is defined on the object (even if null, it counts as defined)
 *
 * @example
 * hasProperty({ a: null }, 'a') // true
 * @example
 * hasProperty({}, 'a') // false
 */
function hasProperty(object, path) {
    return typeof (0, get_1.default)(object, path) !== 'undefined';
}
exports.hasProperty = hasProperty;
/**
 * @param {moment.MomentInput}  date1 a MomentInput representing the first date. E.g. a date string in "YYYY-MM-DD" format.
 * In the backend, this is a LocalDate.
 * @param {moment.MomentInput}  date2 the date which date1 is compared to (before or equal to).
 * @returns {boolean} If date1 or date2 null, true, otherwise, whether or not date1 is before or equal to date2
 */
function beforeOrEqualsDate(date1, date2) {
    if (!date1 || !date2) {
        return true;
    }
    var m1 = (0, moment_1.default)(date1);
    return !m1.isAfter(date2);
}
exports.beforeOrEqualsDate = beforeOrEqualsDate;
/**
 * @param {moment.MomentInput}  date1 a MomentInput representing the first date. E.g. a date string in "YYYY-MM-DD" format.
 * In the backend, this is a LocalDate.
 * @param {moment.MomentInput}  date2 the date which date1 is compared to (is before).
 * @returns {boolean} If date1 or date2 null, true, otherwise, whether or not date1 is before to date2
 */
function beforeDate(date1, date2) {
    if (!date1 || !date2) {
        return true;
    }
    var m1 = (0, moment_1.default)(date1);
    return !m1.isAfter(date2) && !m1.isSame(date2);
}
exports.beforeDate = beforeDate;
/**
 * Returns the number of days (integer) between two dates, or null
 * Be aware when using this in EntityConfig validations, that the backend version of this only takes LocalDate arguments - it will break if passed strings.
 * The frontend version of this function handles that fine.
 * @param {moment.MomentInput} date1 a MomentInput representing the first date. E.g. a date string in "YYYY-MM-DD" format.
 * In the backend, this is a LocalDate.
 * @param {moment.MomentInput} date2 the latter date to be compared.
 * @returns {number | null} The number of days between dateOne and dateTwo. If dateTwo < dateOne, it will return a negative number.
 * If either date1 or date2 are null, it will return null.
 *
 * @example
 * daysBetween("2020-01-01", "2020-01-04"); // 3
 * @example
 * daysBetween(new Date("2020-01-01"), new Date("2020-01-04")); // 3
 * @example
 * daysBetween("2020-01-04", "2020-01-01"); // -3
 * @example
 * daysBetween(null, "2020-01-01"); // null
 */
function daysBetween(date1, date2) {
    if (!date1 || !date2) {
        return null;
    }
    var m1 = (0, moment_1.default)(date1);
    var m2 = (0, moment_1.default)(date2);
    if (!m1.isValid() || !m2.isValid()) {
        return null;
    }
    return m2.diff(m1, 'days');
    // old:
    // return dateUtils.daysBetween(date1, date2)
}
exports.daysBetween = daysBetween;
/**
 *
 * @param {moment.MomentInput} date1 a MomentInput representing the first instant. E.g. an ISO8601 UTC string eg. "2007-12-03T10:15:30.00Z".
 * In the backend, this is an Instant.
 * @param {moment.MomentInput} date2 the instant which date1 is compared to (before or equal to).
 * @returns {boolean} If date1 or date2 null, true, otherwise, whether or not date1 is after date2
 */
function afterInstant(date1, date2) {
    if (!date1 || !date2) {
        return true;
    }
    var m1 = (0, moment_1.default)(date1);
    return m1.isAfter(date2);
}
exports.afterInstant = afterInstant;
/**
 *
 * @param {moment.MomentInput} date1 a MomentInput representing the first instant. E.g. an ISO8601 UTC string eg. "2007-12-03T10:15:30.00Z".
 * In the backend, this is an Instant.
 * @param date2 the instant which date1 is compared to
 * @returns -1 if date1 is before date2, 1 if date1 is after date2, and 0 if they are equal.
 * @throws if either argument is null (to match backend behavior.)
 */
function compareDate(date1, date2) {
    if (!date1 || !date2) {
        throw new Error("Simulating backend NullPointerException: argument \"".concat(date1 ? 'date2' : "date1", "\" passed to compareDate is null."));
    }
    var m1 = (0, moment_1.default)(date1);
    if (m1.isBefore(date2)) {
        return -1;
    }
    if (m1.isAfter(date2)) {
        return 1;
    }
    return 0;
}
exports.compareDate = compareDate;
//# sourceMappingURL=index.js.map